import type { EvmUserOperationNetwork } from "@coinbase/cdp-core";

/**
 * Base-only chain-ID -> CDP user-operation "network" string mapping.
 *
 * The CDP SDK's `sendUserOperation` takes a network *name* (`"base"` / `"base-sepolia"`),
 * not a chain ID. This app only ever supports Base Sepolia (84532) and Base Mainnet (8453)
 * per Build.md, so this mapping is intentionally narrow — any other chain ID is treated as
 * unsupported/wrong-network rather than silently guessed at.
 */
const BASE_CHAIN_ID_TO_CDP_NETWORK: Record<number, EvmUserOperationNetwork> = {
  8453: "base",
  84532: "base-sepolia",
};

export function cdpNetworkForChainId(chainId: number): EvmUserOperationNetwork | null {
  return BASE_CHAIN_ID_TO_CDP_NETWORK[chainId] ?? null;
}

export function chainNameForChainId(chainId: number): string {
  switch (chainId) {
    case 8453:
      return "Base Mainnet";
    case 84532:
      return "Base Sepolia";
    default:
      return `Chain ${chainId}`;
  }
}
